import React, { useCallback } from 'react'
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SideStyle from '../style/sideStyle';
import Param from '../store/param';


const WorkflowSoftInsert = () => {
  const style         = SideStyle();
  const activeStep    = Param.Get('activeStep');
  const compress      = Param.Get('compress');
  const thick         = Param.Get('thick');
  const setParam      = Param.Get('setParam');

  const onClick = useCallback((step) => {
    setParam(s => {s.activeStep = step});
  })
  function getActive(step){

    if (activeStep == step) {
      return `${style.button} ${style.buttonSelected}`;
    } else if (activeStep >= step-1) {
      return style.button;
    } else {
      return style.buttonDisable;
    }
    
  }
  function getDisabled(step){
    if (activeStep >= step) {
      return false;
    } else {
      return true;
    }
  }

  // onclick bindling way is not proper, we would need to change function to class and use bind function.
  return(
    <div>
      <Box className={style.moduleTitle}>WorkFlow</Box>

      <div className={style.workflow}>
        {/* Line 1 */}
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}></Grid>
              <Grid item xs={10}>
                <Button className={getActive(0)} onClick={() => onClick(0)} size="small">Setup</Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}>
                <FontAwesomeIcon icon={['fas', 'angle-double-right']} />
              </Grid>
              <Grid item xs={10}>
                <Button className={getActive(1)} onClick={() => onClick(1)} size="small">Alignment</Button>
              </Grid>
            </Grid>
          </Grid>


          <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}>
                <FontAwesomeIcon icon={['fas', 'angle-double-right']} />
              </Grid>
              <Grid item xs={10}>
                <Button className={getActive(2)} onClick={() => onClick(2)} disabled={getDisabled(1)} size="small">Modeling</Button>
              </Grid>
            </Grid>
          </Grid>

          {/* <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}>
                <FontAwesomeIcon icon={['fas', 'angle-double-right']} />
              </Grid>
              <Grid item xs={10}>
                <Button className={getActive(3)} onClick={() => onClick(3)} disabled={getDisabled(2)} size="small">Output</Button>
              </Grid>
            </Grid>
          </Grid> */}

        </Grid>
      </div>
    </div>
  );
}
export default WorkflowSoftInsert;
